import { useMemo } from 'react';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import { Snowflake as Root } from '@simplywallst/ui-charts/Snowflake';

import { Tooltip as SnowflakeTooltip } from './Tooltip';

interface Props {
  portfolio: Portfolio;
}

export const Snowflake = ({ portfolio }: Props) => {
  const normalisedPoints: [number, number, number, number, number] =
    useMemo(() => {
      const { scores } = portfolio.snowflake;
      const { value, future, past, health, dividend } = scores;

      if (portfolio.isAnalysisRestricted) {
        return [0, 0, 0, 0, 0];
      }

      return [
        (value || 0) + 1,
        (future || 0) + 1,
        (past || 0) + 1,
        (health || 0) + 1,
        (dividend || 0) + 1,
      ];
    }, [portfolio]);

  return (
    <Root points={normalisedPoints}>
      <Root.Labels />
      <Root.Segments>
        <SnowflakeTooltip
          section="dividend"
          portfolio={portfolio.isAnalysisRestricted ? null : portfolio}
        >
          <Root.DividendSegment />
        </SnowflakeTooltip>
        <SnowflakeTooltip
          section="past"
          portfolio={portfolio.isAnalysisRestricted ? null : portfolio}
        >
          <Root.PastSegment />
        </SnowflakeTooltip>
        <SnowflakeTooltip
          section="value"
          portfolio={portfolio.isAnalysisRestricted ? null : portfolio}
        >
          <Root.ValueSegment />
        </SnowflakeTooltip>
        <SnowflakeTooltip
          section="health"
          portfolio={portfolio.isAnalysisRestricted ? null : portfolio}
        >
          <Root.HealthSegment />
        </SnowflakeTooltip>
        <SnowflakeTooltip
          section="future"
          portfolio={portfolio.isAnalysisRestricted ? null : portfolio}
        >
          <Root.FutureSegment />
        </SnowflakeTooltip>
      </Root.Segments>
    </Root>
  );
};
